<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
         <div class="card m-4 m-lg-3">
        <div class="card-body">
           <div class="row p-0 align-items-center">
              <div class="col mt-4 ms-lg-4">
                <h4>Group Charges</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn me-4"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none d-sm-block"
                  type="button"
                  @click:button="addGroupCharges()"
                >
                  <i class="fa-solid fa-plus"></i>
                 Add Group Charges
                </llp-button>
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-block d-sm-none"
                  type="button"
                  @click:button="addGroupCharges()"
                >
                  <i class="fa-solid fa-plus"></i>
                 Add Group
                </llp-button>
              </div>
            </div>
          
          <!-- Dropdown and Go Button -->
          <div class="row p-lg-4 position-relative">
             <div v-if="loading" class="loader-overlay">
            <div class="spinner"></div>
                    </div>
            <llp-datatable
                  ref="usersTable"
                  :columns="columns"
                  :data="GroupChargesData"
                  :lazy="true"
                  :paginator="true"
                   :totalRecords="totalRecords"
                    :rows="perpage"
                    :page="currentPage"
                  scrollable
                  @onPageChange="onPageChange"
                >
                 <template #actions="{ data }">
                    <div class="text-center">
                       <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="EditGroupCharges(data.id)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="AssignGroupCharges(data.id,data.role_id)"
                      >
                        <i class="fa fa-users"></i>
                      </button>
                      <!-- <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="DeleteGroupCharges(data.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button> -->
                    </div>
                 </template>
            </llp-datatable>
          </div>
        </div>
      </div>
      </div>
     
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from '@/services/network.service';
export default {
  data() {
    return {
      loading:false,
      selectedStatus: "", 
      showTableData: false, 
      user_id:localStorage.getItem('User_id'),
      tableData: [], 
      showaddadminSpinner: false, 
      initialTableData: [], 
      updateMessage: "",
      GroupChargesData:[],
      currentPage: 1,
      totalRecords: 0,
      perpage: 10,
      columns: [
        { field: "s_no", className: "text-center", header: "S.No" },
        { field: "name", className: "text-center", header: "Group Name" },
         { field: "role_name", className: "text-center", header: "Role Name" },
        {
          field: "action",
          header: "Action",
          body: "actions",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
    };
  },
  mounted()
  {
     this.resetDataTable();
this.fetchingGroupCharges();
  },
  watch: {
    "$route.params.roleName": function () {
      this.resetDataTable();
    },
  },
  methods: {
     resetDataTable: function () {
      this.rows = [];
      this.totalRecords = 0;
      this.$refs.usersTable.resetPaginator();
    },
     onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
      this.loading= true;
      this.fetchingGroupCharges(this.currentPage, this.perpage);
    },
    async fetchingGroupCharges()
    {
    try {
      
         this.loading= true;
        const response = await NetworkService.get(`get-charges-list/${this.user_id}?per_page=${this.perpage}&page=${this.currentPage}`);
        if (response.status === false || !response.data || response.data.length === 0) {
      this.GroupChargesData = [];
      this.totalRecords = 0;
      this.$refs.toast.show(response.message || "No charges found", "info");
      this.loading = false;
      return;
    }
        const startIndex = (this.currentPage - 1) * this.perpage;
      this.GroupChargesData = response.data.map((charges,index)=>
      {
        return{
           s_no: startIndex + index + 1,
           id:charges.id,
           role_id:charges.role_id,
           name:charges.name,
           role_name:charges.roles.name
        }
      })
      this.totalRecords = response.pagination.total
      this.loading = false;
    } catch (error) {
      this.loading =false;
      this.$refs.toast.show("Unable to fetching the group charges", "error");
    }
      
    },
    async AssignGroupCharges(id,role_id)
    {
    
      this.$router.push({
        name: "AssignGroupCharges",
        params: { id:id,role_id:role_id },
      });
    },
    addGroupCharges()
    {
      this.$router.push('/add-group-charges')
    },
    EditGroupCharges(id)
    {
        this.$router.push({
        name: "EditGroupCharges",
        params: { id:id},
      });
    },
    async DeleteGroupCharges(id)
    {
      try {
        console.log("id",id);
        
      } catch (error) {
      this.$refs.toast.show("Unable to deleting the group charges", "error");
        
      }
      
    }
  },
};
</script>
